import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'TheSans Veolia Regular', sans-serif;
    font-weight: ${({ theme }) => theme.weight.normal};
  }

  #root {
    height: 100vh;
    font-size: 10px;
    background: ${({ theme }) => theme.color.background};
    color: ${({ theme }) => theme.color.black};
  }

  button {
    background-color: transparent;
    border: none;
    padding: unset;
  }

  input[type=number] {
    -moz-appearance: textfield; /* Firefox */
  }

  input, textarea {
    /* Remove ios safari input inner shadow */
    appearance: none;
    font-family: 'TheSans Veolia', sans-serif;
    outline: none;
    border: none;
  }

  button {
    font-family: 'TheSans Veolia', sans-serif;
  }

  b, strong {
    font-weight: ${({ theme }) => theme.weight.semi};
  }

`

export default GlobalStyle
